// ONE horizontal inset for a full-screen card and the flush rows inside it: the Customers list's grouped edge
// (`groupedEdgePx`: 14 phone / 16 tablet / 20 web), the SAME number on the card header and on every flush
// row (CalmRow, TickList, InlineRadioGroup `bare`), so a row's text lines up with the header's icon tile.
// The card header follows the list edge (it was 16 on phone; it is now 14, like the Customers rows).
// FullScreenSectionCard (and so DrawerSectionCard) publishes the edge; rows read it.
import { createContext, useContext } from 'react';
import { foundation } from '../../../ui/tokens';
import { groupedEdgePx } from '../groupedList/groupedListTokens';
import { useResponsiveLayout } from '../../../hooks/ui/useResponsiveLayout';

/** Flush body: breathing room under the last row (rows stay edge to edge). */
export const FLUSH_BODY_BOTTOM = foundation.spacePx[2];

export const FlushInsetContext = createContext(null);

/** The grouped edge in px for this width; `touch` (a finger) picks tablet over web, as the Customers list does. */
export function useGroupedEdge(touch) {
  const { isMobile, isTouch } = useResponsiveLayout();
  return groupedEdgePx({ isPhone: isMobile, isTouch: touch ?? isTouch });
}

/** The inset (px number) for rows: the enclosing card's, else the grouped edge for this width. */
export function useFlushInset(touch) {
  const ctx = useContext(FlushInsetContext);
  const own = useGroupedEdge(touch);
  return ctx ?? own;
}
